let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("03fhc")), load("ijb5t")]).then(() => parcelRequire('kRwCG'));